/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
/**
 * @file rate
 * @description 评分 星星现在是svg写文件里 打开了每行最大长度的限制
 * @author jc
*/
import React, { useState, useMemo, useCallback, useContext, useEffect, Fragment } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
const Rate = ({ prefixCls: customizePrefixCls, allowClear = true, allowHalf = false, className, style, count = 5, defaultValue = 0, value = 0, tooltips = [], disabled = false, tags = [], onFocus, onBlur, onHoverChange, onChange, renderCharacter, onLabelChange, renderTag }) => {
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('rate', customizePrefixCls);
    const STAR_FIX = `${prefixCls}-star`; // ⭐容器
    const STAR_INNER_FIX = `${STAR_FIX}-inner`; // ⭐
    const STAR_FULL_FIX = `${STAR_FIX}-full`; // 高分⭐
    const STAR_LOW_FIX = `${STAR_FIX}-low`; // 低分⭐
    const STAR_NORMAL_FIX = `${STAR_FIX}-normal`; // 普通⭐
    const STAR_DISABLED = `${STAR_FIX}-disabled`; // 禁用的⭐
    const STAR_HALF_FIX = `${STAR_FIX}-half`; // 半⭐
    const LABEL_FIX = `${prefixCls}-label`; // 辅助文案
    const TAGS_FIX = `${prefixCls}-tags`; // 标签
    const TAGS_SELECT_FIX = `${TAGS_FIX}-select`; // 选中的标签
    const TAGS_DISABLED = `${TAGS_FIX}-disabled`; // 禁用的标签
    const [hoverValue, updateHoverValue] = useState(-1);
    const [currValue, updateCurrValue] = useState(allowHalf ? defaultValue : defaultValue - 1);
    const [isHover, updateIsHover] = useState(false);
    const [selectTags, updateSelectTags] = useState([]);
    const list = useMemo(() => new Array(count).fill('').map((_item, index) => index), [count]);
    useEffect(() => {
        value && updateCurrValue((allowHalf && value % 1) ? value : value - 1);
    }, [value]);
    // 获取焦点
    const handleFocus = useCallback(() => {
        onFocus && onFocus();
    }, []);
    // 鼠标移出
    const handleBlur = useCallback(() => {
        updateHoverValue(-1);
        updateIsHover(false);
        onBlur && onBlur();
    }, []);
    // 鼠标经过
    const handleHoverChange = useCallback((value, isHalf) => {
        if (disabled) {
            return;
        }
        const _value = isHalf ? value + 0.5 : value;
        updateHoverValue(_value);
        updateIsHover(true);
        onHoverChange && onHoverChange(isHalf ? _value : _value + 1);
    }, [disabled]);
    // 点击值变更
    const handleChange = useCallback((value, isHalf) => {
        if (disabled) {
            return;
        }
        // 点击时的值和当前值进行判断
        // 判断的目的是 如果设置了allowClear 就设置value为-1进行清空
        const clickValue = isHalf ? value + 0.5 : value;
        const _value = allowClear && clickValue === currValue ? -1 : clickValue;
        // 内部的计算从0开始
        // eg: 半颗星星返回0.5 1颗星星返回0 ...
        // 暂时先在CB函数里 + 1 如果要改currvalue会有不小改动
        // 同样在handleHoverChange做了相同的处理
        updateCurrValue(_value);
        onChange && onChange(isHalf ? _value : _value + 1);
    }, [currValue, disabled]);
    // star class
    const getCurrClassName = useCallback(value => {
        const halfValue = count / 2;
        const getActiveClass = _value => {
            let classname = '';
            _value <= halfValue
                ? classname = ` ${value <= _value ? STAR_LOW_FIX : STAR_NORMAL_FIX}`
                : classname = ` ${value <= _value ? STAR_FULL_FIX : STAR_NORMAL_FIX}`;
            return classname;
        };
        // hover样式
        if (isHover && hoverValue !== -1) {
            return `${STAR_FIX}${getActiveClass(hoverValue)}`;
        }
        // 点击样式
        if (currValue !== -1) {
            return `${STAR_FIX}${getActiveClass(currValue)}`;
        }
        // 默认样式
        return STAR_FIX;
    }, [currValue, hoverValue, isHover, count]);
    // 点击选择标签
    const handleSelectTag = useCallback((item, index) => {
        if (disabled) {
            return;
        }
        let newLabels = [...selectTags];
        let currLabel = selectTags.find(({ key }) => key === index);
        // 如果已经存在，取消选中
        if (currLabel) {
            newLabels = newLabels.filter(({ key }) => key !== index);
            updateSelectTags(newLabels);
        }
        // 如果不存在，插入
        else {
            newLabels.push({ key: index, text: item });
            updateSelectTags(newLabels);
        }
        onLabelChange && onLabelChange(item, newLabels.map(item => item === null || item === void 0 ? void 0 : item.text));
    }, [selectTags]);
    // label class
    const getLabelClass = useCallback(index => {
        let baseClass = `${TAGS_FIX}-item`;
        let isSelect = selectTags.find(({ key }) => key === index);
        return classNames(baseClass, isSelect ? TAGS_SELECT_FIX : '');
    }, [tags, selectTags]);
    // 渲染⭐
    const renderStar = useCallback((value, index) => {
        let isCurrentHalf = allowHalf
            && !isHover
            && (currValue - value > 0)
            && (currValue - value < 1); // 是否半⭐
        let isHoverHalf = allowHalf
            && (hoverValue - value > 0)
            && (hoverValue - value < 1); // 是否半⭐
        let isHalf = isCurrentHalf || isHoverHalf;
        let IconLeft = (<svg className={`${STAR_INNER_FIX}-left-svg`} viewBox="0 0 16 16" focusable="false" data-icon="star" fill="currentColor" aria-hidden="true">
                <path d="M7.69013023,2.45403461 C7.790097,2.4047144 7.89613451,2.3814534 8.00053121,2.38163544 L7.99961383,11.7516344 L7.999,11.751 L5.23767823,13.2028077 C5.10138222,13.2744675 4.94526032,13.2991856 4.793494,13.2731336 C4.4124677,13.2077272 4.15660721,12.845822 4.22201361,12.4647957 L4.22201361,12.4647957 L4.75,9.389 L2.516094,7.21145716 C2.40579775,7.10394377 2.33404155,6.96305337 2.31194523,6.81061931 C2.25648476,6.42801877 2.52168419,6.07290015 2.90428473,6.01743969 L2.90428473,6.01743969 L5.991,5.57 L7.37214898,2.77195304 C7.4402962,2.6338947 7.55205843,2.52215456 7.69013023,2.45403461 Z"></path>
            </svg>);
        let IconRight = (<svg className={`${STAR_INNER_FIX}-right-svg`} viewBox="0 0 16 16" focusable="false" data-icon="star" fill="currentColor" aria-hidden="true">
                <path d="M7.99986281,2.38163459 C8.25776985,2.38183708 8.50576461,2.52513046 8.62759969,2.77207707 L8.62759969,2.77207707 L10.008,5.57 L13.0948664,6.01814893 C13.2472813,6.04027642 13.3881443,6.11205203 13.4956302,6.2223549 C13.7654388,6.49923458 13.7597066,6.94241299 13.4828269,7.21222159 L13.4828269,7.21222159 L11.249,9.389 L11.7770174,12.4649763 C11.8030652,12.6167184 11.7783592,12.7728154 11.7067249,12.909097 C11.5268502,13.2513019 11.1036211,13.3828964 10.7614163,13.2030217 L10.7614163,13.2030217 L7.999,11.751 Z"></path>
            </svg>);
        let CustomIcon = renderCharacter && renderCharacter(index);
        if (CustomIcon) {
            IconLeft = <div className={`${STAR_INNER_FIX}-left-svg`}>{CustomIcon}</div>;
            IconRight = <div className={`${STAR_INNER_FIX}-right-svg`}>{CustomIcon}</div>;
        }
        return (<div key={value} className={`${getCurrClassName(value)} ${disabled ? STAR_DISABLED : ''}`}>
                <div className={`${STAR_INNER_FIX} ${isHalf ? STAR_HALF_FIX : ''}`}>
                    {/* 根据allowHalf来设置左半边是点击是否需要设置半颗星的值及渲染效果 */}
                    <div className={`${STAR_INNER_FIX}-left`} onMouseOver={() => handleHoverChange(value, allowHalf)} onClick={() => handleChange(value, allowHalf)}>{IconLeft}</div>
                    <div onMouseOver={() => handleHoverChange(value, false)} onClick={() => handleChange(value, false)} className={`${STAR_INNER_FIX}-right`}>{IconRight}</div>
                </div>
            </div>);
    }, [currValue, hoverValue, isHover, disabled, allowHalf]);
    // 渲染辅助文案
    const renderLabel = useCallback(() => {
        let hoverLabel = tooltips[hoverValue | 0];
        let currLabel = tooltips[currValue | 0];
        let label = isHover ? hoverLabel : currLabel;
        return <span className={LABEL_FIX}>{label}</span>;
    }, [hoverValue, currValue, isHover]);
    // 渲染标签
    const renderTags = useCallback(() => {
        if (!tags || tags.length === 0) {
            return;
        }
        return (<div className={TAGS_FIX}>
                {tags.map((item, index) => (<div key={index} className={classNames(getLabelClass(index), disabled ? TAGS_DISABLED : '')} onClick={() => handleSelectTag(item, index)}>
                        {renderTag ? renderTag(item, index) : item}
                    </div>))}
            </div>);
    }, [tags, selectTags, disabled]);
    return (<Fragment>
            <div className={classNames(className, prefixCls)} style={style} onMouseEnter={() => handleFocus()} onMouseLeave={() => handleBlur()}>
                {list.map((value, index) => renderStar(value, index))}
                {renderLabel()}
            </div>
            {renderTags()}
        </Fragment>);
};
export default Rate;
